
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { useAuth } from '@/context/SupabaseAuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import RoleManagementSection from '@/components/admin/RoleManagementSection';
import UsersSection from '@/components/admin/users/UsersSection';
import { useAdminSettings } from '@/hooks/useAdminSettings';

const UserManagementPage = () => {
  const { user } = useAuth();
  const { handleLogout } = useAdminSettings();

  return (
    <AdminLayout onLogout={handleLogout} userRole={user?.role}>
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-6">User-Role Login Manager</h1>
        
        <Tabs defaultValue="users" className="space-y-4">
          <TabsList>
            <TabsTrigger value="users">Users</TabsTrigger>
            <TabsTrigger value="roles">Role Management</TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="space-y-4">
            <UsersSection />
          </TabsContent>
          
          <TabsContent value="roles">
            <RoleManagementSection />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
};

export default UserManagementPage;
